<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import type { OrderStatus } from '../types/Order';
import { orderStatusList } from '../types/Order';

const props = defineProps<{ modelValue: OrderStatus | undefined, id?: string, itemClass?: string }>();
const emit = defineEmits<{ (e: 'update:modelValue', newVal: string): void }>();

const { t } = useI18n();
const statusOpts = orderStatusList.map(item => ({
  label: t(`status.${item}`),
  value: item,
}));
</script>

<template>
  <Dropdown
    :id="props.id"
    :model-value="props.modelValue"
    :options="statusOpts"
    option-label="label"
    option-value="value"
    class="w-full"
    :class="props.itemClass ?? ''"
    :placeholder="$t('general.select')"
    show-clear
    @change="emit('update:modelValue', $event.value)"
  >
    <template #option="slotProps">
      <StatusTag :type="slotProps.option.value" />
    </template>
  </Dropdown>
</template>

<style scoped>

</style>
